import React from 'react'
import PropTypes from 'prop-types'
import {Flex, Text, useMultiStyleConfig} from '@salesforce/retail-react-app/app/components/shared/ui'
import {ErrorIcon} from '../icons/index'

const ErrorMessage = ({message, containerProps = {}, iconProps = {}, textProps = {}}) => {
    const styles = useMultiStyleConfig('ErrorMessage')

    return (
        <Flex {...styles.container} {...containerProps}>
            <ErrorIcon {...styles.icon} {...iconProps} />
            <Text {...styles.text} {...textProps}>
                {message}
            </Text>
        </Flex>
    )
}

ErrorMessage.propTypes = {
    message: PropTypes.node,
    containerProps: PropTypes.object,
    iconProps: PropTypes.object,
    textProps: PropTypes.object
}

export default ErrorMessage
